export default initData => {
    const {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        isHybridAppContext,
        isNativeAppContext,
        splitTests,
        version
    } = initData;

    // Always turn off SPA for native app web views
    if (isHybridAppContext) {
        featureSwitches['spa'] = false;
    }

    return {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        isHybridAppContext,
        isNativeAppContext,
        splitTests,
        version
    };
};
